export const ROUTE_PATHS = {
  IASTART: '/iastart',
  IADOCS: '/iadocs',
  IADOCS_EXTRACT: '/iadocs/extract',
  IADOCS_TYPING: '/iadocs/typing',
  IADOCS_UNBUNDLE: '/iadocs/unbundle',
  ERROR: '/error',
}
